import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    message,
    ProTableOt, DeleteButton, PatchButton, PostButton,
    Form,
    useProTableOt,
    setParamsFilter,

} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import NewArrivalsListForm from "./new_arrivals_list_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import NewArrivalsListEdit from './new_arrivals_list_edit'
import dayjs from 'dayjs';

const NewArrivalsListTable = ({
    rowKey = "list_id",
    keyPrefix = "library.backstage.new_arrivals_list_management",
    showAllColumns = true,
    propsShowColumns,
    propslist_id,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [tableSearchParams, setTableSearchParams] = useState({
        list_id: propslist_id || null,
        // start_planneddate: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        // end_planneddate: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    });
    const columns = [
        {
            title: t("display_title"),
            key: "task_name",
            dataIndex: "task_name",
            sorter:false,

        },
        {
            title: t("start_date"),
            key: "start_time",
            dataIndex: "start_time",
            sorter:false,
            
        },
        {
            title: t("end_date"),
            key: "end_time",
            dataIndex: "end_time",
            sorter:false,
            
        },
        {
            title: t("display_description"),
            key: "task_explaination",
            dataIndex: "task_explaination",
            sorter:false,
            
        },
        {
            title: t("book_quantity"),
            key: "bibs_list_items_data",
            dataIndex: "bibs_list_items_data",
            sorter:false,
            render: (text, record, index) => {
                let bibs_list_items_data_quantity = text.length
                return <Row justify="center">
                    <Col>
                        {bibs_list_items_data_quantity}
                    </Col>
                </Row>
            }
        },
        {
            title: t("creator"),
            key: "create_user_name",
            dataIndex: "create_user_name",
            sorter:false,

        },
        {
            title: t("creation_time"),
            key: "create_time",
            dataIndex: "create_time",
            sorter:false,
            render: (text, record, index) => {
                return <Typography.P>
                    {dayjs(text).format('YYYY-MM-DD HH:mm:ss')}
                </Typography.P>
            }
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();

    const navigate = useNavigate()


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    
    const NewArrivalsListController = useCRUDController({
        apiRoute: "/library/newbib_display",
        onFinish,
        onBefore
    })

    useEffect(() => {
        checkAll();
       
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Row gutter={[8, 8]}>
                            <Col>
                                <PostButton
                                    ischildren={false}
                                    onClick={() => {
                                        navigate(`../new_arrivals_list_management?mode=new`)
                                    }}
                                />
                            </Col>

                        </Row>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        ...newTableSearchParams,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return NewArrivalsListController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            NewArrivalsListController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                    claimdate: !!formValue?.claimdate ? formValue?.claimdate : null
                                }
                            })
                            NewArrivalsListController.patchData(patchData)
                        },
                        deleteData: NewArrivalsListController.deleteData
                    }
                }}
                PropsPatchForm={<NewArrivalsListForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={false}
                propsDelete
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
                extraActionRender={(record) => {
                    return (<PatchButton
                        onClick={() => {
                            navigate(`../new_arrivals_list_management?mode=edit&list_id=${record?.list_id}`)
                        }}
                    >

                    </PatchButton>)
                }}
            />
        </Col>
    </Row>)

}
const NewArrivalsList = ({
    keyPrefix = "library.backstage.new_arrivals_list_management",
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('list_id');
    const mode = searchParams.get('mode');
    return (
        <Row gutter={[10, 20]} >
            {
                (mode === "view" || !mode) && <Col span={24}>
                    <NewArrivalsListTable
                        keyPrefix={keyPrefix}
                    />
                </Col>
            }
            {
                (mode === "new" || mode === "edit") && <Col span={24}>
                    <NewArrivalsListEdit keyPrefix={keyPrefix} />
                </Col>
            }


        </Row>
    );
};
export { NewArrivalsListTable }
export default NewArrivalsList;
